import { computed, onMounted } from 'vue'
import { useStore } from 'vuex';

export default () => {
    const store = useStore()
    const asyncForEach = async (array, callback) => {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    }

    const getProfile = (profiles, profileId) => {
      let profileIndex = profiles.findIndex(item => item._id == profileId)
      return (profileIndex >= 0) ? profiles[profileIndex] : {company: '', fullname: ''}
    }

    const getUserBalance = async () => {
      await store.dispatch('FETCHuserProfile', {userId: null, phone: null})
      await store.dispatch('FETCHuserBalance', store.getters.userProfile._id)
    }
    
    const showContentDeliverer = computed(() => {
      return jwtAccessValid.value && userProfile.value.checked && isDeliverer.value
    })
    const userProfile = computed(() => store.getters.userProfile)
    const jwtAccessValid = computed(() => store.getters.jwtAccessValid)

    //const isDeliverer = computed(() => store.getters.isDeliverer)
    // const isReciever = computed(() => store.getters.isReciever)
    // const isReceiver = computed(() => store.getters.isReciever)
    const isReciever = computed(() => store.getters.userProfile.role.type == 'receiver')
    const isReceiver = computed(() => store.getters.userProfile.role.type == 'receiver')
    const isDeliverer = computed(() => store.getters.userProfile.role.type == 'deliverer')
    const isDriver = computed(() => store.getters.userProfile.role.type == 'driver')

    const isAdmin = computed(() => store.getters.isAdmin)
    const isWholesaler = computed(() => store.getters.userProfile.role.name == 'wholesaler')
    const isManager = computed(() => store.getters.userProfile.role.name == 'manager')
    const isManagerFB = computed(() => store.getters.userProfile.role.name == 'managerFB')

    // const inspectToken = async () => {
    //   let status = await store.dispatch("inspectToken");
    //   if (!status) {
    //     store.commit('removeToken')
    //     router.push({name: "login"})
    //     document.location.reload(true);
    //   }

    //   onMounted(inspectToken)
    //};

    const isMobile = computed(() => {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    })
    

    return {
      getUserBalance,
      userBalance: computed(() => store.getters.userBalance),
      jwtAccessValid,
      userProfile,
      asyncForEach,
      getProfile,
      isDeliverer,
      isReceiver,
      isReciever,
      showContentDeliverer,
      isAdmin,
      isWholesaler,
      isManager,
      isMobile,
      isDriver,
      isManagerFB,

  }
}
